import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-auth-error',
  standalone: true,
  imports: [AsyncPipe, NgIf, RouterLink],
  template: `
    <main class="auth-error">
      <section class="auth-error__card">
        <p class="auth-error__eyebrow">SIGN-IN</p>
        <h1>We could not complete sign-in.</h1>
        <p>Authentication did not return a valid session. The reason is shown below so it can be diagnosed without restarting the login loop.</p>
        <pre *ngIf="errorMessage$ | async as errorMessage">{{ errorMessage }}</pre>
        <a routerLink="/">Return to sign in</a>
      </section>
    </main>
  `,
  styleUrls: ['./auth-error.component.scss']
})
export class AuthErrorComponent {
  private readonly auth = inject(AuthService);

  readonly errorMessage$ = this.auth.error$.pipe(
    map(error => error?.message || 'No error details were returned by Auth0.')
  );
}
